import React, {useState, useEffect} from "react";
import AddDialogConversationComponent from "./AddDialogConversationComponent";
import firebase from "firebase";
import {storage} from "../../../firebase";
import axios from "axios";
import fileDownload from "js-file-download";

function AddDialogConversationPage(
    {
        classLevel,
        handleClassLevel,
        editAssignment,
        editAssignmentName,
        setEditAssignmentLoading,
        setEditAssignmentProgress,
        actionChoice,
        databaseChoice
    }
) {

    const [sounds, setSounds] = useState([]);
    const [assignment, setAssignment] = useState(null);
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [progressText, setProgressText] = useState('');
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');
    const [fileNames, setFileNames] = useState([]);
    const [assignmentLoaded, setAssignmentLoaded] = useState(false);
    const [showDirections, setShowDirections] = useState(false);
    const [directionsURL, setDirectionsURL] = useState('');
    const [assignmentName, setAssignmentName] = useState('');
    const [replaceAssignment, setReplaceAssignment] = useState(false);
    const [assignmentToReplace, setAssignmentToReplace] = useState('')



    useEffect(() => {
        setSuccess(false);
        setLoading(false);
        async function fetchData() {
            setAssignmentLoaded(false)
            setAssignment(null);
            setSounds([]);
            setReplaceAssignment(false);
            let tmpFileNames = [];
            firebase.storage().ref().child('/assignments/Samoan10' + classLevel + '/dialogAssignments/assignments').listAll()
                .then((data) => {
                    data.items.forEach((folderRef) => {

                        tmpFileNames.push(folderRef.location.path_.split('/')[4])
                    })
                }).catch(e => console.log(e));
            setFileNames(tmpFileNames)
            const directionsPDF = firebase.storage().ref().child('/extraFiles/Directions.pdf')
            await directionsPDF.getDownloadURL()
                .then(url => setDirectionsURL(url))
        }
        async function fetchAssignmentData() {
            setAssignmentLoaded(true);
            setSuccess(false);
            setLoading(false);
            setEditAssignmentLoading(true)
            setAssignmentName(editAssignmentName);
            setReplaceAssignment(true)
            const assignmentToReplaceRef = firebase.storage().ref().child('/assignments/Samoan10' + classLevel + '/dialogAssignments/assignments/' + editAssignmentName)
            await assignmentToReplaceRef.getDownloadURL()
                .then(url => {
                    setAssignmentToReplace(url)
                    setEditAssignmentProgress(50)
                })
        }
        if(editAssignment){
            fetchAssignmentData().then(()=>{
                setEditAssignmentProgress(0)
                setEditAssignmentLoading(false)
            }).catch(e=>console.log(e))

        } else {

            fetchData().then(() => console.log('ready')).catch(e => console.log(e))
        }
    }, [classLevel, editAssignment, actionChoice, databaseChoice]);

    const handleDownload = () => {
        axios.get(directionsURL, {
            responseType: 'blob',
        })
            .then((res) => {
                fileDownload(res.data, 'Directions.pdf')
            })
    };

    const handleDownloadAssignment = () => {
        axios.get(assignmentToReplace, {
            responseType: 'blob',
        })
            .then((res) => {
                fileDownload(res.data, assignmentName)
            })
    }

    const handleSetDialogConversationData = (e) => {
        setError('');
        setLoading(false)
        let tmpSounds = [];
        if (e.target.files) {
            for (let i = 0; i < e.target.files.length; i++) {
                tmpSounds.push(e.target.files[i])

            }
            setSounds(tmpSounds)
        }
        if(e.target.name === "assignment") {
            let reader = new FileReader();
            reader.readAsText(e.target.files[0]);
            reader.onload = async (e) =>{
                let a = e.target.result;
                let content = await JSON.parse(a)
                setAssignment(content);
                setAssignmentLoaded(true)
            };
        }
    };


    const uploadAssignment = () => {
        setLoading(true);
        for (let i = 0; i < sounds.length; i++) {
            const uploadTask = storage.ref(`sounds/${sounds[i].name}`).put(sounds[i]);
            uploadTask.on(
                "state_changed",
                () => {
                },
                error => {
                    console.log(error)
                },
                () => {
                    storage
                        .ref("sounds")
                        .child(sounds[i].name)
                        .getDownloadURL()
                        .then(() => {
                                setProgress(prevState => prevState + Math.round(50/sounds.length));
                                setProgressText('Uploading audio files')
                            }
                        ).catch(e => setError('Sounds could not be uploaded'))
                }
            )
        }
        if(!error) {
            const JSONobj = JSON.stringify(assignment, null, 2);
            if(replaceAssignment) {
                const blobObj = new Blob([JSONobj], {type: "application/json"});
                const uploadTask = storage.ref(`assignments/Samoan10` + classLevel + `/dialogAssignments/assignments/` + assignmentName).put(blobObj);
                uploadTask.on(
                    "state_changed",
                    () => {
                    },
                    error => {
                        console.log(error)
                    },
                    () => {
                        storage
                            .ref("assignments/Samoan10" + classLevel + "/dialogAssignments/assignments")
                            .child(assignmentName)
                            .getDownloadURL()
                            .then(url => {
                                    setLoading(false);
                                    setSuccess(true)
                                }
                            )
                            .catch(e => setError('Assignment could not be uploaded'));
                    }
                )
            } else {
                const blobObj = new Blob([JSONobj], {type: "application/json"});
                const uploadTask = storage.ref(`assignments/Samoan10` + classLevel + `/dialogAssignments/assignments/assignment${fileNames.length + 1}.json`).put(blobObj);
                uploadTask.on(
                    "state_changed",
                    () => {
                    },
                    error => {
                        console.log(error)
                    },
                    () => {
                        storage
                            .ref("assignments/Samoan10" + classLevel + "/dialogAssignments/assignments")
                            .child(`assignment${fileNames.length + 1}.json`)
                            .getDownloadURL()
                            .then(url => {
                                    setLoading(false);
                                    setSuccess(true)
                                }
                            )
                            .catch(e => setError('Assignment could not be uploaded'));
                    }
                )
            }
        }
    };

    const handleShowDirections = () => {
        setShowDirections(!showDirections)
    };


    const handleClearData = () => {
        setSounds([]);
        setAssignment(null);
        setLoading(false);
        setProgress(0);
        setProgressText('');
        setSuccess(false);
        setError('');
        setAssignmentLoaded(false);
        let tmpFileNames = [];
        firebase.storage().ref().child('/assignments/Samoan10' + classLevel + '/dialogAssignments/assignments').listAll()
            .then((data) => {
                data.items.forEach((folderRef) => {

                    tmpFileNames.push(folderRef.location.path_.split('/')[4])
                })
            }).catch(e => console.log(e));
        setFileNames(tmpFileNames)
    };

    return (
        <>
            <AddDialogConversationComponent
                handleSetDialogConversationData={handleSetDialogConversationData}
                uploadAssignment={uploadAssignment}
                loading={loading}
                progress={progress}
                showDirections={showDirections}
                handleShowDirections={handleShowDirections}
                progressText={progressText}
                error={error}
                success={success}
                assignmentLoaded={assignmentLoaded}
                classLevel={classLevel}
                handleClassLevel={handleClassLevel}
                handleDownload={handleDownload}
                replaceAssignment={replaceAssignment}
                handleDownloadAssignment={handleDownloadAssignment}
                handleClearData={handleClearData}
                editAssignment={editAssignment}
                assignment={assignment}
            />
        </>
    )
}

export default AddDialogConversationPage
